export const ITEMS_PER_PAGE = 24
export const ITEMS_PER_SECTION = 4
export const SELLER_DECATHLON = `1`
export const HAVE_WINDOW = typeof window !== `undefined`
